import halkaBox from "halkabox";
import domready from "domready";

/**
 * Returns the page language code used for translations.
 * Defaults to 'en' if language is not German.
 * @returns {'de' | 'en'}
 */
function getPageLanguage() {
  const htmlLang = document.documentElement.lang;
  return htmlLang?.toLowerCase().startsWith('de') ? 'de' : 'en';
}

/**
 * Gets the prefix label for the lightbox links based on language.
 * @param {'de' | 'en'} language
 * @returns {string}
 */
function getLightboxLabelPrefix(language) {
  const labels = {
    en: 'Open media in lightbox',
    de: 'Medien in der Lightbox öffnen',
  };
  return labels[language] || labels.en;
}

/**
 * Adds accessible aria-labels to lightbox links inside the given element.
 * It prepends a prefix indicating the link opens a lightbox.
 * If an aria-label exists, it is preserved and prefixed.
 * Otherwise, uses figcaption and copyright text for description.
 * @param {Element} el
 */
function addLabelsToLightboxLinks(el) {
  const language = getPageLanguage();
  const labelPrefix = getLightboxLabelPrefix(language);

  const lightboxLinks = el.querySelectorAll('a[class*="lightbox-"]');
  lightboxLinks.forEach((link) => {
    const existingLabel = link.getAttribute('aria-label')?.trim();

    if (existingLabel) {
      // Prefix existing label
      link.setAttribute('aria-label', `${labelPrefix}: ${existingLabel}`);
    } else {
      const figcaption = link.querySelector('figcaption')?.textContent?.trim();
      const copyright = link.querySelector('.copyright-text')?.textContent?.trim();

      const labelParts = [];
      if (figcaption) labelParts.push(figcaption);
      if (copyright) labelParts.push(copyright);

      const description = labelParts.length > 0 ? `: ${labelParts.join('. ')}` : '';
      link.setAttribute('aria-label', `${labelPrefix}${description}`);
    }
  });
}

// @deprecated use photoswipe instead
domready(() => {
  const potentialLightBoxElements = document.querySelectorAll('.gallery, .teaser, .textpic, .text-columns, .map, .image-row');
  if (!potentialLightBoxElements) return;

  potentialLightBoxElements.forEach((el) => {
    const lightboxID = el.dataset.lightbox || el.dataset.gallery;

    if (lightboxID) {
      halkaBox.run(lightboxID);
      addLabelsToLightboxLinks(el);
    }
  });
});
